/**
 * First Party Data integrations
 */
const LIVERAMP_ACTIVE =
	typeof LVR_ACTIVE !== "undefined" && LVR_ACTIVE ? LVR_ACTIVE : false;
const AMAZON_ACTIVE =
	typeof APS_ACTIVE !== "undefined" && APS_ACTIVE ? APS_ACTIVE : false;

// Liveramp
if (LIVERAMP_ACTIVE) {
	if (!!document.querySelector("#fpd-liveramp") === false) {
		const script = document.createElement("script");
		script.id = "fpd-liveramp";
		script.src =
			"https://launchpad-wrapper.privacymanager.io/98ec4cf7-bd1a-4bb4-b818-8ca4bd46afcf/launchpad-liveramp.js";
		document.head.insertAdjacentElement("beforeend", script);
	}
}

export const callAtsEnvelope = (identifier) => {
	if (LIVERAMP_ACTIVE && identifier && typeof __tcfapi !== "undefined") {
		__tcfapi("addEventListener", 2, (tcData, success) => {
			if (
				success &&
				(tcData.eventStatus === "tcloaded" ||
					tcData.eventStatus === "useractioncomplete")
			) {
				atsenvelopemodule.setAdditionalData({
					consentString: tcData.tcString,
					consentType: "gdpr",
					id: [identifier],
					type: "emailHashes",
				});
				__tcfapi("removeEventListener", 2, (success) => {}, tcData.listenerId);
			}
		});
	}
};

// Amazon APS
// on "usernavready" se l'utente è loggato
export const callApsRenew = (identifier) => {
	if (
		AMAZON_ACTIVE &&
		identifier &&
		typeof __tcfapi !== "undefined" &&
		typeof apstag !== "undefined"
	) {
		// console.log("usernav: event listener set up")
		__tcfapi("addEventListener", 2, (tcData, success) => {
			if (success && tcData.eventStatus === "tcloaded") {
				// console.log("usernav: ", `${identifier} sent!`);
				apstag.rpa({
					gdpr: {
						enabled: true,
						consent: tcData.tcString,
					},
					hashedRecords: [{ type: "email", record: identifier }],
				});
				__tcfapi("removeEventListener", 2, (success) => {}, tcData.listenerId);
			}
		});
	}
};

// login o cambio email (attivazione nuova email)
export const callApsUpdate = (identifier) => {
	if (
		AMAZON_ACTIVE &&
		identifier &&
		typeof __tcfapi !== "undefined" &&
		typeof apstag !== "undefined"
	) {
		// console.log("user login/email change: event listener set up");
		__tcfapi("addEventListener", 2, (tcData, success) => {
			if (success && tcData.eventStatus === "tcloaded") {
				apstag.upa({
					gdpr: {
						enabled: true,
						consent: tcData.tcString,
					},
					hashedRecords: [{ type: "email", record: identifier }],
				});
				// console.log("user login/email change: ", `${identifier} sent!`);
				__tcfapi("removeEventListener", 2, (success) => {}, tcData.listenerId);
			}
		});
	}
};

// la CMP è stata utilizzata e l'utente è loggato
if (AMAZON_ACTIVE && typeof __tcfapi !== "undefined") {
	__tcfapi("addEventListener", 2, (tcData, success) => {
		if (success && tcData.eventStatus === "useractioncomplete") {
			const user_nav = document.querySelector(
				"#user_nav #_user_panel_container",
			);
			if (!!user_nav && user_nav.dataset.id) {
				// console.log("change CMP: ", user_nav.dataset.id, " sent!");
				apstag.upa({
					gdpr: {
						enabled: true,
						consent: tcData.tcString,
					},
					hashedRecords: [{ type: "email", record: user_nav.dataset.id }],
				});
			}
		}
	});
}

const fpdReady = new Event("fpdready");
document.dispatchEvent(fpdReady);
